import * as auth from "./auth";
import axios from "axios";

const getConfig = () => ({
  headers: {
    Authorization: "Bearer " + auth.getCookie(),
    "Content-Type": "multipart/form-data"
  }
});

export const getBoards = async () => {
    const config = { 'headers': { 'Authorization': 'Bearer ' + auth.getCookie() } };
    try {
        const response = await axios.get(`/api/admin/boards`, config);
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};

export const saveBoard = async (item) => {
    const config = { 'headers': { 'Authorization': 'Bearer ' + auth.getCookie() } };
    try {

        const response = await axios.post('/api/admin/boards', item, config);
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};

export const deleteBoard = async (id) => {
    const config = { 'headers': { 'Authorization': 'Bearer ' + auth.getCookie() } };
    try {
        const response = await axios.delete(`/api/admin/boards/${id}`, config);
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};

export const fetchBoardData = async (alias) => {
    const config = { 'headers': { 'Authorization': 'Bearer ' + auth.getCookie() } };
    try {
        const response = await axios.get(`/api/admin/boards/${alias}`, config);
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};

export const saveIndicator = async (item) => {
    const config = { 'headers': { 'Authorization': 'Bearer ' + auth.getCookie() } };
    try {

        const response = await axios.post('/api/admin/boards/indicator', item, config);
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};

export const closeIndicatorMonth = async (item) => {
    const config = { 'headers': { 'Authorization': 'Bearer ' + auth.getCookie() } };
    try {

        const response = await axios.post('/api/admin/boards/close', item, config);
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};

export const saveValueIndicator = async (data) => {
    const config = { 'headers': { 'Authorization': 'Bearer ' + auth.getCookie() } };
    try {

        const response = await axios.post('/api/admin/boards/value', { data: data }, config);
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};

export const fetchBoardDisplay = async (alias) => {
    const config = { 'headers': { 'Authorization': 'Bearer ' + auth.getCookie() } };
    try {
        const response = await axios.get(`/api/admin/boards/display/${alias}`, config);
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};

export const getIndicators = async (alias) => {
    const config = { 'headers': { 'Authorization': 'Bearer ' + auth.getCookie() } };
    try {
        const response = await axios.get(`/api/admin/boards/indicators/${alias}`, config);
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};

export const deleteIndicator = async (data) => {
    const config = { 'headers': { 'Authorization': 'Bearer ' + auth.getCookie() } };
    try {

        const response = await axios.post('/api/admin/boards/delete', data, config);
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};


//Доска ТО
export const getTOBoards = async () => {
  try {
    const response = await axios.get(
      "/api/admin/to-boards/get/data",
      getConfig()
    );
    return response.data.data;
  } catch (exception) {
    console.error("Ошибка при загрузке ТО:", exception);
    return {};
  }
};

export const getData = async () => {
    const config = { 'headers': { 'Authorization': 'Bearer ' + auth.getCookie() } };
    try {
        const response = await axios.get(`/api/admin/to-boards`, config);
        return response.data.data;
    } catch (exception) {
        console.log(exception);
    }
};

export const createPrice = async (items) => {
    const config = { 'headers': { 'Authorization': 'Bearer ' + auth.getCookie() } };
    try {
        const response = await axios.post(`/api/admin/to-boards`, {
            brand: items.brand,
            model: items.model,
            items: items.items,
            id: items.id,
        }, config);
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};

export const deletePrice = async (id) => {
    const config = { 'headers': { 'Authorization': 'Bearer ' + auth.getCookie() } };
    try {
        const response = await axios.delete(`/api/admin/to-boards/${id}`, config);
        return response.data.data;
    } catch (exception) {
        console.log(exception);
    }
};

/**
 * Получить список слайдеров для конкретной доски
 * GET /api/admin/to-boards/{board}/sliders
 * @param {number|string} boardId
 */
export const getSliders = async (boardId) => {
    try {
        const response = await axios.get(
            `/api/admin/to-boards/${boardId}/sliders`,
            getConfig()
        );
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};

/**
 * Создать новый слайдер на доске
 * POST /api/admin/to-boards/{board}/sliders
 * @param {number|string} boardId
 * @param {{name:string,enabled:boolean}} payload
 */
export const createSlider = async (boardId, payload) => {
    try {
        const response = await axios.post(
            `/api/admin/to-boards/${boardId}/sliders`,
            payload,
            getConfig()
        );
        // возвращает { data: {id,…} }
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};

/**
 * Получить один слайдер (с изображениями)
 * GET /api/admin/to-boards/{board}/sliders/{slider}
 * @param {number|string} boardId
 * @param {number|string} sliderId
 */
export const fetchSlider = async (boardId, sliderId) => {
    try {
        const response = await axios.get(
            `/api/admin/to-boards/${boardId}/sliders/${sliderId}`,
            getConfig()
        );
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};

/**
 * Обновить слайдер
 * PUT /api/admin/to-boards/{board}/sliders/{slider}
 * @param {number|string} boardId
 * @param {number|string} sliderId
 * @param {{name:string,enabled:boolean}} payload
 */
export const updateSlider = async (boardId, sliderId, payload) => {
    try {
        const response = await axios.put(
            `/api/admin/to-boards/${boardId}/sliders/${sliderId}`,
            payload,
            getConfig()
        );
        return response.data.data;
    } catch (exception) {
        return exception.response;
    }
};

/**
 * Удалить слайдер
 * DELETE /api/admin/to-boards/{board}/sliders/{slider}
 * @param {number|string} boardId
 * @param {number|string} sliderId
 */
export const deleteSlider = async (boardId, sliderId) => {
    try {
        const response = await axios.delete(
            `/api/admin/to-boards/${boardId}/sliders/${sliderId}`,
            getConfig()
        );
        return response.data;
    } catch (exception) {
        return exception.response;
    }
};

/**
 * Загрузить фото в слайдер
 * @param {number|string} boardId
 * @param {number|string} sliderId
 * @param {File[]} files
 */
export const uploadSliderImages = async (boardId, sliderId, files) => {
  const form = new FormData();
  files.forEach(f => form.append("images[]", f));

  const response = await axios.post(
    `/api/admin/to-boards/${boardId}/sliders/${sliderId}/images`,
    form,
    getConfig()
  );
  // Предполагаем, что API отдаёт { data: [ {...}, ... ] }
  return response.data.data;
};

export const deleteSliderImage = (boardId, sliderId, imageId) =>
  axios.delete(
    `/api/admin/to-boards/${boardId}/sliders/${sliderId}/images/${imageId}`,
    getConfig()
  );

export const toggleSliderImageStatus = async (boardId, sliderId, imageId) => {
  try {
    const response = await axios.post(
      `/api/admin/to-boards/${boardId}/sliders/${sliderId}/images/${imageId}/status`,
      {},
      getConfig()
    );
    return response.data;
  } catch (exception) {
    return exception.response;
  }
};

/**
 * Получить все картинки для двух слайдеров одной доски одним запросом
 * @param {number|string} boardId
 * @returns Promise<{slider_1: Array, slider_2: Array}>
 */
export const getAllSliderImages = async (boardId) => {
  const response = await axios.get(
    `/api/admin/to-boards/${boardId}/slider-images`,
    getConfig()
  );
  return response.data.data;
};